import React from "react";
import AIMenuGeneration from "ai-menu/AIMenuGeneration";
import AIMenuItems from "ai-menu/AIMenuItems";


export default function AIMenu({ aiMenu }) {
  if (aiMenu.status !== "done") {
    return <AIMenuGeneration aiMenu={aiMenu} />;
  }

  return <AIMenuItems menuItems={aiMenu.menuData.menu_items}/>;
}
